import React, { Component } from "react";
import "./Download.scss";
import { downloadService } from "../../../services/subscriberService";
import { CheckValue, formatBytes } from "../../../services/CommonFunction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

class Download extends Component {
  state = {
    download: [],
    id: null,
    show: true,
  };

  componentDidMount() {
    this.final = this.final.bind();
    this.subscription = downloadService
      .getDownload()
      .subscribe(async (data) => {
        if (data) {
          const { download } = this.state;
          const temp = download.filter((el) => el.id === data.id);
          if (!temp.length || !temp[0].show || temp[0].status === "cancel") {
            const splits = data.download.split("/");
            const name = splits[splits.length - 1].split(".");
            const text = `${data.title || name[0]}.${name[1]}`;

            download.push({
              title: data.title,
              id: data.id,
              uid: data.uid,
              download: `${data.download}`,
              progress: 0,
              size: { total: 0, progress: 0 },
              status: "pending",
              response: null,
              show: true,
              name: text.replace(/ /g, "_"),
              xhr: new XMLHttpRequest(),
            });
            await this.setState((prevState) => ({
              id: CheckValue(prevState.id) ? prevState.id : data.uid,
            }));
            // }
          }
        }
      });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  componentDidUpdate = async (nextProps, nextState) => {
    if (nextState.id !== this.state.id) {
      const pending = this.filterData("pending");
      if (CheckValue(this.state.id)) {
        pending.status = "start";
        await this.setData(pending);
        this.callDownload(pending, this.callOnLoad);
      } else if (CheckValue(pending)) {
        this.setState({ id: pending.uid });
      }
    }
  };

  progressEvent = (progressEvent) => {
    var percentCompleted = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    const data = this.filterData("id");
    if (CheckValue(data) && percentCompleted !== data.progress) {
      if (percentCompleted < 100) {
        data.progress = percentCompleted;
        data.size.total = formatBytes(progressEvent.total, 1);
        data.size.progress = formatBytes(progressEvent.loaded, 1);
      } else {
        data.progress = 100;
        data.size.progress = data.size.total;
      }
      this.setData(data);
    }
  };

  filterData = (status = "start") => {
    if (status !== "id") {
      const data = this.state.download.filter((el) => el.status === status);
      return data.length ? { ...data[0] } : null;
    } else {
      const data = this.state.download.filter((el) => el.uid === this.state.id);
      return data.length ? { ...data[0] } : null;
    }
  };

  callOnLoad = (response) => {
    const data = this.filterData("id");
    if (CheckValue(data)) {
      data.progress = 100;
      data.status = "complete";
      data.response = response;
      this.setData(data);
      setTimeout(() => {
        data.show = false;
        this.setData(data);
      }, 5000);
      this.final(data);
    }
  };

  setData = (data) => {
    this.setState((prevState) => ({
      download: prevState.download.map((el) =>
        el.uid === data.uid ? data : el
      ),
    }));
  };

  callDownload = async (data, onLoad) => {
    // return;
    const { xhr } = data;
    xhr.open("GET", data.download, true);
    xhr.responseType = "blob";
    xhr.onprogress = this.progressEvent;
    xhr.onload = function () {
      onLoad(this.response);
    };
    xhr.onerror = (err) => {
      console.error("Failed to download video");
      const data = this.filterData("id");
      if (CheckValue(data)) {
        data.status = "reload";
        this.setData(data);
        this.setState({ id: null });
      }
    };
    xhr.send();
  };

  final = (data) => {
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(data.response);
    let tag = document.createElement("a");
    tag.href = imageUrl;
    tag.target = "_blank";
    tag.download = `${data.name}`;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
    this.setState({ id: null });
    // toasterSubscriber.sendToasterData({
    //   showToaster: true,
    //   showImage: true,
    //   message: `${data.title || name[0]} video download`
    // });
  };

  abort = (el, status = true) => {
    if (status) {
      el.status = "cancel";
      setTimeout(() => {
        el.show = false;
        this.setData(el);
      }, 5000);
    } else {
      el.status = "pause";
    }
    el.xhr.abort();
    this.setData(el);
    this.setState({ id: null });
  };

  reload = async (el) => {
    el.status = "pending";
    await this.setData(el);
    if (!CheckValue(this.state.id)) {
      this.setState({ id: el.uid });
    }
  };

  render() {
    const { show, download } = this.state;
    const data = download.filter((el) => el.show);
    const rowData = data.map((el, index) => {
      return (
        <div className="download-row" key={el.uid}>
          <div className="downlod-top">
            <p className="title">{el.name || ""}</p>
            {/* <span className="download-cross" onClick={() => this.abort(el)}></span> */}
            {el.status === "reload" || el.status === "pause" ? (
              <FontAwesomeIcon
                className="dowload_icon"
                icon={faRedo}
                onClick={() => this.reload(el)}
              />
            ) : null}
            {/* {el.status === 'start'? <FontAwesomeIcon className="dowload_icon" icon={faPause} onClick={() => this.abort(el,false)} />:null} */}
            {el.status === "start" ? (
              <FontAwesomeIcon
                className="dowload_icon"
                icon={faTimesCircle}
                onClick={() => this.abort(el)}
              />
            ) : null}
            {el.status === "pending" ? (
              <span className="download-status">Waiting...</span>
            ) : null}
            {el.status === "complete" ? (
              <span className="download-status">Downloaded</span>
            ) : null}
            {el.status === "cancel" ? (
              <span className="download-status">Canceled</span>
            ) : null}
          </div>
          {el.status !== "pending" && el.size.total !== 0 ? (
            <span className="progress-data">
              {el.size.progress || 0}/{el.size.total || 0}
            </span>
          ) : null}
          <span className="progress-count">{el.progress || 0}%</span>
          <progress
            className="download-progress"
            id="file"
            value={el.progress}
            max="100"
          ></progress>
        </div>
      );
    });
    return (
      <React.Fragment>
        {data.length ? (
          <div
            className={`download-container${show ? " width400" : ""}${
              show ? "" : " primaryBg"
            }`}
          >
            <div
              className={`arrow`}
              onClick={() => this.setState({ show: !show })}
            ></div>
            <div
              className="download-body"
              style={{ display: show ? "" : "none" }}
            >
              {rowData}
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export default Download;
